import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { useIsClientReady } from '@belong/common/useIsClientReady';
import { ModalTracker } from '@belong/common/ModalTracker';
import { twMerge } from '@belong/common/twMerge';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import css from './ModalBase.module.css.js';

const ModalBase = /*#__PURE__*/React.forwardRef(function ModalBase({
  isOpen,
  onDismiss,
  preventDismissOnOutsideClick = false,
  children,
  overlayClassName,
  overlayChildren,
  contentClassName,
  childrenClassName,
  contentRef,
  name,
  dangerouslyBypassScrollLock,
  initialFocusRef,
  trackingData = {}
}, ref) {
  const isClientReady = useIsClientReady();
  if (!isClientReady) return null;
  function handleOverlayDismiss() {
    if (!preventDismissOnOutsideClick) onDismiss();
  }
  return /*#__PURE__*/createPortal(jsx(ModalTracker, {
    name: name,
    isOpen: isOpen,
    trackingDat: trackingData,
    children: jsx(DialogOverlay, {
      ref: ref,
      dangerouslyBypassScrollLock: dangerouslyBypassScrollLock,
      initialFocusRef: initialFocusRef,
      className: twMerge('flex justify-center', css.overlay, overlayClassName),
      isOpen: isOpen,
      onDismiss: handleOverlayDismiss,
      children: jsxs(Fragment, {
        children: [overlayChildren, jsx(DialogContent, {
          "aria-label": `${name}-dialog`,
          className: twMerge('p-0 m-0 table table-fixed bg-transparent', contentClassName),
          ref: contentRef,
          children: jsx("div", {
            className: twMerge('table-cell md:align-middle w-full md:py-2xl relative', childrenClassName),
            children: children
          })
        })]
      })
    })
  }), document.getElementById('modal-root'));
});

export { ModalBase };
